// extracted by mini-css-extract-plugin
module.exports = {"flex":"Tab_flex__3DN1C","active":"Tab_active__1KW21","text":"Tab_text__2XNqx"};